import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.content = this.element.querySelector('table');
    if (!this.content) return;

    this.icon = document.createElement('div');
    this.icon.classList.add('p-table__scrollIcon');
    this.element.appendChild(this.icon);

    this.state = {};
    this.intersection = new IntersectionObserver(this.#onIntersect.bind(this));
    this.state._wrapperWidth = null;
    this.state._isScroll = false;
    this.state._isViewed = false;
    this.state.contentWidth = null;

    Object.defineProperties(this.state, {
      wrapperWidth: {
        get: () => this.state._wrapperWidth,
        set: (value) => {
          this.state._wrapperWidth = value;
          if (this.state.contentWidth > this.state.wrapperWidth) {
            this.state.isScroll = true;
          } else {
            this.state.isScroll = false;
          }
        },
      },
      isScroll: {
        get: () => this.state._isScroll,
        set: (value) => {
          this.state._isScroll = value;
          this.#updateView();
        },
      },
      isViewed: {
        get: () => this.state._isViewed,
        set: (value) => {
          this.state._isViewed = value;
          this.#updateView();
        },
      },
    });

    this.#setWidth();
    this.intersection.observe(this.element);
  }

  #setWidth() {
    this.state.contentWidth = this.content.clientWidth;
    this.state.wrapperWidth = this.element.clientWidth;
  }

  #updateView() {
    if (this.state.isScroll && !this.state.isViewed) {
      this.element.style.overflowX = 'scroll';
      this.icon.style.display = 'block';
      requestAnimationFrame(() => {
        this.icon.style.opacity = 1;
      });
    } else {
      setTimeout(() => {
        this.icon.style.opacity = 0;
        const handleFadeOut = () => {
          this.icon.style.display = 'none';
          this.icon.removeEventListener('transitionend', handleFadeOut);
        };
        this.icon.addEventListener('transitionend', handleFadeOut);
      }, 1500);
    }
  }

  #onIntersect(entries) {
    if (entries[0].isIntersecting) {
      this.state.isViewed = true;
      this.intersection.unobserve(this.element);
    }
  }
}
